<breadcrumb [breadcrumbName]="constants.CATALOG" />
<router-outlet></router-outlet>